/**
 * Customer Account API 엔드포인트 discovery.
 * shop_id 기반 URL을 직접 조립하지 않고, 스토어 도메인의 well-known 문서에서 얻음
 * https://shopify.dev/docs/api/customer
 */

export interface ICaaEndpoints {
  authorizationEndpoint: string;
  tokenEndpoint: string;
  endSessionEndpoint: string;
  graphqlApiEndpoint: string;
}

interface IOpenIdConfiguration {
  authorization_endpoint: string;
  token_endpoint: string;
  end_session_endpoint: string;
}

interface ICustomerAccountApiConfiguration {
  graphql_api: string;
}

const cache = new Map<string, Promise<ICaaEndpoints>>();

const fetchDiscovery = async (shopDomain: string): Promise<ICaaEndpoints> => {
  const [openIdConfig, caaConfig] = await Promise.all([
    fetch(`https://${shopDomain}/.well-known/openid-configuration`).then((res) => res.json() as Promise<IOpenIdConfiguration>),
    fetch(`https://${shopDomain}/.well-known/customer-account-api`).then((res) => res.json() as Promise<ICustomerAccountApiConfiguration>),
  ]);

  return {
    authorizationEndpoint: openIdConfig.authorization_endpoint,
    tokenEndpoint: openIdConfig.token_endpoint,
    endSessionEndpoint: openIdConfig.end_session_endpoint,
    graphqlApiEndpoint: caaConfig.graphql_api,
  };
};

/** 스토어 도메인 단위로 in-memory 캐시 (앱 세션 중 1회만 fetch) */
export const discoverCaaEndpoints = (shopDomain: string): Promise<ICaaEndpoints> => {
  const cached = cache.get(shopDomain);
  if (cached) return cached;

  const promise = fetchDiscovery(shopDomain).catch((error) => {
    cache.delete(shopDomain);
    throw error;
  });

  cache.set(shopDomain, promise);
  return promise;
};
